import React from "react";
import { FormattedNumber } from "react-intl";

const App = () => {
  return (
    <FormattedNumber style="unit" unit="day" unitDisplay="long" value={7} />
  );
};

export default App;
